// IE11 polyfills
import 'core-js/fn/array';
import 'core-js/fn/weak-map';
import 'react-app-polyfill/ie9';

// IE 10, react-intl polyfill
if (!window.Intl) {
  require('intl');
}

// Object.values() method polyfill
const objectToValuesPolyfill = object => {
  Object.keys(object).map(key => object[key]);
};

Object.values = Object.values || objectToValuesPolyfill;



// WEBPACK FOOTER //
// ./src/common/polyfill.js